import { useMemo } from 'react'
import cn from 'classnames'

import { ContentSteps, useStepFlow } from 'src/lib/useStepFlow'

import { FirstStep, FourthStep, SecondStep, ThirdStep } from './ui/steps'

import Logo from '../../icons/logo.webp'

import { normalizeBrowserLang, TLang } from 'src/constants/langs'

import cls from './styles.module.scss'

const stepComponents = {
    [ContentSteps.FIRST]: FirstStep,
    [ContentSteps.SECOND]: SecondStep,
    [ContentSteps.THIRD]: ThirdStep,
    [ContentSteps.FOURTH]: FourthStep,
}

const WheelLand = () => {
    const { step, goToNextStep } = useStepFlow()
    const StepComponent = stepComponents[step]

    const currentLang = useMemo<TLang>(() => {
        const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
        return normalizeBrowserLang(nav)
    }, [])

    return (
        <div
            className={cn(cls.root, {
                [cls['root--el']]: currentLang === 'el',
            })}
        >
            <img src={Logo} alt="Logo" className={cls.logo_wrapper} />

            <div
                className={cn(cls.container, {
                    [cls.container__odd_step]:
                        step === ContentSteps.FIRST ||
                        step === ContentSteps.THIRD,
                    [cls.container__even_step]:
                        step === ContentSteps.SECOND ||
                        step === ContentSteps.FOURTH,
                })}
            >
                <StepComponent
                    onNext={goToNextStep}
                    step={step}
                    lang={currentLang}
                />
            </div>
        </div>
    )
}

export default WheelLand
